<template>
  <div class="sections-lateral-spaces">
    <div class="px-6 2xl:px-24 py-32 bg-white ">
      <!-- Container -->

      <div class=" text-slider flex md:justify-between fullitems-center gap-10 xl:gap-40 flex-col xl:flex-row items-center">

        <div class="flex flex-col w-full xl:w-2/4 flex-wrap order-2 xl:order-1">
          <img src="/products/nnp-vpn-logo-typo.svg" class="w-64 mb-14 xl:block hidden">
          <span class="h4 mb-8">{{ $t('NNP_VPN_WELCOME_PHRASE') }}</span>
          <span class="h6 mb-4">{{ $t('NNP_VPN_WELCOME_DESC') }}</span>

          <div class="my-8 block">
            <nuxt-link to="/home/privacy/vpn">
              <button class="fira-ui-btn primary">
                {{ $t('DISCOVER_NNP_VPN') }}
              </button>
            </nuxt-link>
          </div>
        </div>

        <div class="xl:flex-1 flex 2xl:justify-end w-full order-1 xl:order-2">
          <img src="/illustrations/vpn/multi-device-protection.svg" alt="" class="service_illustration">
        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts" setup>
// -------------------------------------------
// Hooks
// -------------------------------------------

const localePath = useLocalePath();

useHead({
  title: 'Nuinalp - Cloud, apps and SaaS solutions'
})
</script>

<style lang="scss" scoped>
.galery {
  background-color: var(--nv-theme);
  padding: 80px;
}

.product-logo {
  height: 60px;
  width: 60px;
}


.service_illustration {
  width: 90%;
  max-width: 450px;
}
@media (screen(2xl)) {
  .service_illustration {
    width: 90%;
    max-width: 850px;
  }
}

/**
* -------------------------------
* Mobile
* -------------------------------
*/

@media screen and (max-width: 480px) {
  .galery {
    padding: 20px;
  }
}
</style>
